// Screening copy, keyed by the stable ids the BFF returns (so clinical routing logic never
// leaks to the client). Transcribed from OPS-9280 (Tab 1). English-only literal strings, like
// the rest of this package.

const SCREENING_QUESTION_TEXT: Record<string, string> = {
  "telemedicine.screening.q.pregnant": "Are you currently pregnant?",
  "telemedicine.screening.q.comorbidities":
    "Have you been diagnosed with, or are you currently being treated for, any of the following: cancer, kidney failure or dialysis, or severe liver disease/cirrhosis?",
  "telemedicine.screening.q.cardiac":
    "Have you had or are you currently being treated for severe cardiac disease, heart attack, stroke, deep vein thrombosis (DVT), or pulmonary embolism (PE) within the past 12 months?"
}

export function screeningQuestionText(id: string): string {
  return SCREENING_QUESTION_TEXT[id] ?? id
}

// The not-eligible page renders whichever exclusion message id the BFF passes. One message is
// defined today (any reason resolves to it); the map is the seam for reintroducing per-reason copy
// later without touching the flow.
const SCREENING_EXCLUSION_TEXT: Record<string, string> = {
  "telemedicine.screening.exclusion.outOfScope":
    "Based on your responses, a Carrot Clinic telehealth visit isn't the right fit for your care right now. Your Care Team can help you find a provider who can support you."
}
const DEFAULT_EXCLUSION_TEXT = SCREENING_EXCLUSION_TEXT["telemedicine.screening.exclusion.outOfScope"]

export function screeningExclusionText(id: string): string {
  return SCREENING_EXCLUSION_TEXT[id] ?? DEFAULT_EXCLUSION_TEXT
}

export const SCREENING_ANSWER_LABELS: Record<string, string> = {
  yes: "Yes",
  no: "No"
}
